import moment from 'moment';
import { DATA_LOADING_STATES } from '@config/Consts';

const setDataStatus = (state, dataStatus) => {
  state.dataStatus = dataStatus;
};

const setConversations = (state, data) => {
  setDataStatus(state, data.dataStatus);
  if (data.dataStatus === DATA_LOADING_STATES.SUCCESS) {
    state.lastTimeDataUpdated = moment();
    state.conversations = data.conversationsList;
  }
};

const setAgentsFilter = (state, selectedAgents) => {
  state.filter.agents = selectedAgents;
};

const setStatusFilter = (state, selectedStatuses) => {
  state.filter.status = selectedStatuses;
};

const setSort = (state, sort) => {
  state.sort = sort;
};

const setLiveIntentsDataStatus = (state, status) => {
  state.intents.dataStatus = status;
};

const setLiveIntents = (state, data) => {
  state.intents.dataStatus = data.dataStatus;
  state.intents.intentsPerDomain = data.intents;
};

const setLiveIntentsFilter = (state, filterValue) => {
  state.filter.liveIntentIds = filterValue;
};

const setPresetValues = (state, preset) => {
  setAgentsFilter(state, preset.agentsFilterList);
  setStatusFilter(state, preset.statusFilterList);
  setLiveIntentsFilter(state, preset.liveIntentsFilter);
  setSort(state, preset.sort);
};

export default {
  setAgentsFilter,
  setStatusFilter,
  setConversations,
  setSort,
  setDataStatus,
  setLiveIntentsDataStatus,
  setLiveIntents,
  setLiveIntentsFilter,
  setPresetValues,
};
